import { useEffect, useState } from "react";
import axios from "axios";
import { Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL;

export default function AdminPanel() {
  const [inquiries, setInquiries] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchInquiries();
  }, []);

  const fetchInquiries = async () => {
    try {
      const res = await axios.get(`${API}/api/inquiries`);
      setInquiries(res.data);
    } catch {
      alert("Failed to load data");
    }
  };

  const deleteInquiry = async (id) => {
    try {
      await axios.delete(`${API}/api/inquiries/${id}`);
      setInquiries((prev) =>
        prev.filter((item) => item.id !== id)
      );
    } catch {
      alert("Delete failed");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("adminAuth");
    navigate("/admin-login");
  };

  return (
    <section className="pt-28 pb-20 px-6 max-w-7xl mx-auto">
      <div className="flex justify-between mb-8">
        <h1 className="text-3xl font-bold">
          Admin Panel - Inquiries
        </h1>

        <button
          onClick={handleLogout}
          className="bg-red-500 text-white px-4 py-2 rounded-xl"
        >
          Logout
        </button>
      </div>

      <table className="min-w-full text-sm text-left border">
        <thead>
          <tr>
            <th className="p-3">Name</th>
            <th className="p-3">Email</th>
            <th className="p-3">Phone</th>
            <th className="p-3">Source</th>
            <th className="p-3">Services</th>
            <th className="p-3">Action</th>
          </tr>
        </thead>

        <tbody>
          {inquiries.map((item) => (
            <tr key={item.id} className="border-t">
              <td className="p-3">{item.name}</td>
              <td className="p-3">{item.email}</td>
              <td className="p-3">{item.phone}</td>
              <td className="p-3">{item.source}</td>
              <td className="p-3">{item.services}</td>
              <td className="p-3">
                <button
                  onClick={() => deleteInquiry(item.id)}
                  className="text-red-600"
                >
                  <Trash2 size={18} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}